import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { showErrorAlert } from "../../../../Helper/SweetAlert";
import { format } from "date-fns";
import { MoonLoader } from "react-spinners";
import Pagination from "../../../../Helper/Pagination";

export default function Transaction() {
  const [transactionlist, settransactionlist] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState({
    orderId: "",
    transaction_id: "",
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [loading, setLoading] = useState(true);

  const gettransactionlist = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
    };

    GetService(
      `${API_URL.GET_TRANSACTION}?orderId=${
        search_key?.orderId ? search_key?.orderId : ""
      }&transaction_id=${
        search_key?.transaction_id ? search_key?.transaction_id : ""
      }&page=${currentPage}&limit=${param?.limit}`
    ).then((res) => {
      console.log(res?.data?.status);
      if (res?.data?.status === true) {
        settransactionlist(res?.data?.data?.item);
        SetTotalPageCount(res?.data?.data?.totalPages);
        SetTotalCount(res?.data?.data?.totalItems);
        setCount(res?.data?.data?.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };
  useEffect(() => {
    gettransactionlist();
  }, [search_key, currentPage]);

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };
  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Transactions List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">
                  Transactions List
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-end">
                    <div className="col-md-4">
                      <label className="font-weight-bold text-small">
                        Order Id
                      </label>
                      <input
                        type="text"
                        name="firstnamesearch"
                        placeholder="Enter OrderId"
                        className="form-control"
                        autoComplete="off" 
                        onChange={(e) => {
                          setTimeout(() => {
                            setsearch_key({
                              orderId: e?.target?.value ? e?.target?.value : "",
                            });
                            setCurrentPage(0);
                          }, 400);
                        }}
                      />
                    </div>
                    <div className="col-md-4 pr-0">
                      <label className="font-weight-bold text-small">
                        Transaction Id
                      </label>
                      <input
                        type="text"
                        name="firstnamesearch"
                        placeholder="Enter Transacrtion Id"
                        className="form-control"
                        autoComplete="off" 
                        onChange={(e) => {
                          setTimeout(() => {
                            setsearch_key({
                              transaction_id: e?.target?.value
                                ? e?.target?.value
                                : "",
                            });
                            setCurrentPage(0);
                          }, 400);
                        }}
                      />
                    </div>
                  </div>

                  <div class="table-responsive mt-4">
                    <table class="table table-hover table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Transaction Id</th>
                          <th>Order Id</th>
                          <th>User Name</th>
                          <th>Amount ($)</th>
                          <th>Transaction Date</th>
                          <th>Payment Gateway</th>
                          <th>Status</th>
                          {/* <th>Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {transactionlist?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + S_No_Count + 1}</td>
                            <td>{item?.transaction_id}</td>
                            <td>{item?.orderId}</td>
                            <td>
                              {item?.userdetails?.fullName
                                ? item?.userdetails?.fullName
                                : "N/A"}
                            </td>
                            <td>{item?.amount}</td>
                            <td>
                              {item?.created_at
                                ? format(
                                    new Date(item?.created_at),
                                    "dd/MM/yyyy"
                                  )
                                : "N/A"}
                            </td>
                            <td>{item?.payment_method}</td>
                            <td>
                              <label
                                className={
                                  item?.status === "COMPLETED"
                                    ? "badge badge-success"
                                    : "badge-danger"
                                }
                              >
                                {item?.status}
                              </label>
                            </td>
                            {/* <td>
                              <span
                                title="view"
                                style={{ cursor: "pointer" }}
                                className="mx-2"
                                data-toggle="modal"
                              >
                                <Link to={"view_order"}>
                                  <i className="text-warning fas fa-eye"></i>{" "}
                                </Link>
                              </span>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                      {transactionlist && transactionlist?.length === 0 && (
                        <tr>
                          <td colSpan="8" className="text-center">
                            <h6 className="p-3"> No Data Found </h6>
                          </td>
                        </tr>
                      )}
                    </table>
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
